import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/lib/auth-context';
import { PermissionsProvider } from '@/lib/permissions-context';
import { queryClient } from '@/lib/query-client';
import { App } from '@/App';
import '@/styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <PermissionsProvider>
          <App />
        </PermissionsProvider>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
